import { type EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

import { ErrorNotifier } from './error-notifier';
import { PortalAvailability } from './portal-availability';
import { ERROR_NOTIFIER, PORTAL_AVAILABILITY } from '../tokens/app.tokens';

export function provideErrorNotifier(): EnvironmentProviders {
  return makeEnvironmentProviders([{ provide: ERROR_NOTIFIER, useClass: ErrorNotifier }]);
}

/**
 * In radice: la alzano l'interceptor degli errori e la connessione a `DxpHub`, che stanno entrambi in
 * radice, e la mostra il componente radice, che c'e' anche quando nessuna cornice e' ancora montata.
 */
export function providePortalAvailability(): EnvironmentProviders {
  return makeEnvironmentProviders([{ provide: PORTAL_AVAILABILITY, useClass: PortalAvailability }]);
}
